import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]',function (element) {
    new Dropdown(element);
});

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element)
});

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-slide-right"
});

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnReset: true
});

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multipleSelectDropdown from './scripts/multiselect-dropdown';
multipleSelectDropdown.init();

import * as rangeSlider from '@elements/range-slider';
rangeSlider.init();

import * as googleMap from './scripts/google-map';
googleMap.init();

import * as tourMap from './scripts/tour-map';
tourMap.init();

import * as activateTab from './scripts/activate-tab';
activateTab.init();
